module.exports = __webpack_public_path__ + "718d877b0dc36007e2fde6d7ed2d7c49.pdf";